const urlForPost = ({ name, postId, prefix }) => {
	const slugPathPart = name ? `${name.toLowerCase().replace(/[^a-z0-9]/gi, '-')}/` : ''
	let postUrl = `/post/${slugPathPart}${postId}`
	if (prefix) {
		postUrl = (prefix[prefix.length - 1] === '/' ? prefix.substr(0, prefix.length - 1) : prefix) + postUrl
	}
	return postUrl
}

export default urlForPost



// WEBPACK FOOTER //
// ./src/utilities/urlForPost.js